import Vue from "vue";
import Router from "vue-router";
import Body from "./components/main/Body.vue";
import PrecheckHost from "./components/main/Precheck/PrecheckHost.vue";
import Welcome from "./components/main/WelcomeScreen/Welcome.vue";
import StepperHost from "./components/main/Stepper/StepperHost.vue";
import Finish from "./components/main/Finish/Finish.vue";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/body",
            component: Body,
            children: [
                {
                    path: "",
                    name: "welcome",
                    component: Welcome,
                },
                {
                    path: "/precheck",
                    name: "precheck",
                    component: PrecheckHost,
                },
                {
                    path: "/stepper",
                    name: "stepper",
                    component: StepperHost,
                },
                {
                    path: "/stepper/:step",
                    name: "initStepper",
                    component: StepperHost,
                    props: (route) => ({
                        startStep: route.params.step,
                    }),
                },
            ],
        },
        {
            path: "/finish",
            name: "finish",
            component: Finish,
        },
    ],
    mode: "abstract",
    linkActiveClass: "active",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },
});
